import styles from './index.module.css';
import poweredByNotable from '../../../../assets/powered-by-notable-logo.png';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <div className={styles.FooterContainer}>
      <div className={styles.FooterSeparator} />
      <div className={styles.SchedulingFooter}>
        <Link
          to="/patient-terms-of-use"
          className={styles.SchedulingFooterText}
          target="_blank"
        >
          Terms of service
        </Link>
        <img
          alt="Powered by Notable"
          src={poweredByNotable}
          className={styles.SchedulingFooterLogo}
        />
      </div>
    </div>
  );
};

export default Footer;
